import { useState } from 'react';
import Constantes from "../../constantes";
import { useNavigate } from 'react-router-dom';

function CrearGrupo() {

    const navigate = useNavigate();

    const [group_name, setGroup_Name] = useState("");
    const [descripcion, setDescripcion] = useState("");


    async function procesarPeticion(e) {
        e.preventDefault()
        try {

            console.log("Enviando datos del grupo:", { group_name, descripcion });

            const respuesta = await fetch(Constantes.RUTA_API + '/grupos/crear', {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ nombre: group_name, descripcion: descripcion })
            })

            const data = await respuesta.json();
            
            if (!data.error) {
                alert(data.message);
                navigate('/GyC');
            } else {
                alert(data.message);
            }

        } catch (error) {
            console.error('Error al enviar:', error);
            alert('Hubo un error al enviar el formulario');
        }
    };

    return (
        <>
            <div className="App d-flex justify-content-center bg-dark text-white">
                    
                <div className="row justify-content-center text-white">
                    <form onSubmit={procesarPeticion}>
                        <div className="mb-4 mt-4">
                        </div>
                        <div className="mb-4 mt-4">
                            <label htmlFor="nombre" className="form-label">Nombre del grupo:</label>
                            <input value={group_name} onChange={(e) => setGroup_Name(e.target.value)} type="text" className="form-control" id="nombre" name="nombre" />
                        </div>
                        <div className="mb-4 mt-4">
                            <label htmlFor="descripcion" className="form-label">Descripción:</label>
                            <input value={descripcion} onChange={(e) => setDescripcion(e.target.value)} type="text" className="form-control" id="description" name="description" />
                        </div>
                        <button type="submit" className="my-4 btn btn-primary" style={{ width: "100%" }}>Crear grupo</button>
                    </form>
                </div>

            </div>
            <title>configuracion de grupo{group_name}</title>
        </>
    );
}



export default CrearGrupo;